/* Resume the existing page, never replay its entrance or replace its content. */
(() => {
  if(window.akBrowserResumeInstalled)return;
  window.akBrowserResumeInstalled=true;
  let suspended=false,frame=0,generation=0,resumeCount=0;
  const interrupted=new Set();
  document.documentElement.dataset.akBrowserResumeState="active";
  document.documentElement.dataset.akBrowserResumeCount="0";
  function capture(){
    if(suspended)return;
    suspended=true;
    document.documentElement.dataset.akBrowserResumeState="suspended";
    cancelAnimationFrame(frame);frame=0;
    for(const animation of document.getAnimations()){
      const target=animation.effect?.target;
      if(!(target instanceof Element) || !target.closest('#MainContent,.ak-search-overlay,.ak-cart-overlay,.ak-directory-menu,.ak-mobile-directory'))continue;
      const timing=animation.effect.getComputedTiming();
      if(Number.isFinite(timing.endTime)&&timing.endTime>0&&(animation.playState==='running'||animation.pending))interrupted.add(animation);
    }
  }
  function restore(){
    if(document.hidden || !suspended)return;
    suspended=false;
    document.documentElement.dataset.akBrowserResumeState="active";
    document.documentElement.dataset.akBrowserResumeCount=String(++resumeCount);
    const token=++generation;
    for(const animation of interrupted){
      if(animation.playState==='idle'||animation.playState==='finished')continue;
      try{animation.finish();}catch(_){}
    }
    interrupted.clear();
    window.dispatchEvent(new CustomEvent('ak:browser-resume'));
    frame=requestAnimationFrame(()=>{
      frame=0;if(token!==generation||document.hidden)return;
      window.dispatchEvent(new CustomEvent('ak:layout-refresh'));
    });
  }
  document.addEventListener('visibilitychange',()=>document.hidden?capture():restore(),true);
  window.addEventListener('pagehide',capture,{capture:true});
  window.addEventListener('pageshow',restore);
  document.addEventListener('freeze',capture);
  document.addEventListener('resume',restore);
  window.addEventListener('blur',capture);
  window.addEventListener('focus',restore);
})();
